import { gql } from "@apollo/client";

const GET_USER = gql`
  query user($id: ID!) {
    user(id: $id) {
      id
      email
      firstName
      lastName
      requiresPasswordChange
      organization {
        id
        name
        logo
        feedbackMail
        apiKey {
          secret
        }
        chatbots {
          id
          name
          type
        }
        zoomAccounts {
          id
          zoomUserId
          createdAt
          user {
            email
            firstName
            lastName
          }
        }
        microsoftAccounts {
          id
          msUserId
          userPrincipalName
          user {
            firstName
            lastName
          }
          createdAt
        }
        metaBusinesses {
          id
          businessName
          businessId
          accessToken
          phoneId
          phoneNumber
          displayName
          about
          description
          vertical
          address
          email
          websites
          pictureData {
            url
            name
            type
            size
          }
          status
          verified

          createdAt
        }
      }
      type
    }
  }
`;

export { GET_USER };
